/** @format */

import { getApi } from '../axios';

export default {
  async getPayments(queryString) {
    return await (
      await getApi({
        baseUrl: window._env_.REACT_APP_QDAK_USER_URL,
        auth: true
      })
    ).get(`admin/payments${queryString}`);
  },
  async patchPayment({ shopId, id, status }) {
    return await (
      await getApi({
        baseUrl: window._env_.REACT_APP_QDAK_USER_URL,
        auth: true
      })
    ).patch(`admin/shops/${shopId}/payments/${id}/status/${status}`);
  },
  async getPaymentsByShopId({ shopId }) {
    return await (
      await getApi({
        baseUrl: window._env_.REACT_APP_QDAK_USER_URL,
        auth: true
      })
    ).get(`admin/shops/${shopId}/payments`);
  },
  async registerCard({ shopId }) {
    return await (
      await getApi({
        baseUrl: window._env_.REACT_APP_QDAK_USER_URL,
        auth: true
      })
    ).post(`/shops/${shopId}/card-info`);
  },
  async getRegistration({ shopId }) {
    return await (
      await getApi({
        baseUrl: window._env_.REACT_APP_QDAK_USER_URL,
        auth: true
      })
    ).get(`/shops/${shopId}/card-info`);
  },
  async deleteRegistration({ shopId }) {
    return await (
      await getApi({
        baseUrl: window._env_.REACT_APP_QDAK_USER_URL,
        auth: true
      })
    ).delete(`/shops/${shopId}/card-info`);
  },
  async getRecurringProperties() {
    return await (
      await getApi({
        baseUrl: window._env_.REACT_APP_QDAK_USER_URL,
        auth: true
      })
    ).get(`admin/payments/recurring-properties`);
  },
  async getExternalCheckoutId(paymentId, body) {
    try {
      const instance = await getApi({ baseUrl: window._env_.REACT_APP_QDAK_USER_URL, auth: true });
      return await instance.post(`/payments/${paymentId}/ack`, body);
    } catch (e) {
      return e;
    }
  },
  async manualPayment({ shopId }) {
    return await (
      await getApi({
        baseUrl: window._env_.REACT_APP_QDAK_USER_URL,
        auth: true
      })
    ).post(`/shops/${shopId}/card-info/pay-once`);
  },
  async importSettlementCsv({ paymentVendorType, file }) {
    const formData = new FormData();
    formData.append('paymentVendorType', paymentVendorType);
    formData.append('file', file);
    return await (
      await getApi({
        baseUrl: window._env_.REACT_APP_QDAK_USER_URL,
        auth: true
      })
    ).post('admin/payments/settlement/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};
